module.exports = __webpack_public_path__ + "img/Logo_SETDIG.255fc283.webp";